module.exports = __webpack_public_path__ + "img/pencil-portrait_cn.8a72285.jpg";